import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/goods-detail/[shop_sku]/page.client.tsx");
